import { render, staticRenderFns } from "./displayMode.vue?vue&type=template&id=cb13e80c&scoped=true"
import script from "./displayMode.vue?vue&type=script&lang=js"
export * from "./displayMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb13e80c",
  null
  
)

export default component.exports